import script from "./chat.vue?vue&type=script&setup=true&name=Chat&lang=js"
export * from "./chat.vue?vue&type=script&setup=true&name=Chat&lang=js"

import "./chat.vue?vue&type=style&index=0&id=17dd0477&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17dd0477"]])

export default __exports__